module.exports = __webpack_public_path__ + "img/worldmap.de8c643a.png";